import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import CircularLoader from "@/components/atoms/CircularLoader";
import ErrorMessage from "@/components/atoms/ErrorMessage";
import Header from "@/components/molecules/Header";
import PaymentDataForm from "@/components/organisms/PaymentDataForm";
import i18n from "@/translate/i18n";
import { useTransactionData } from "@/context/transactionContext";
import { LayoutWrapper1xbet } from "@/components/molecules/Wrappers/LayoutWrapper1xbet";
import { AmountInput1xbet } from "@/components/molecules/Wrappers/AmountInput1xbet";

function PaymentData1xbet() {
  const history = useHistory();
  const { id, token } = useParams();
  const { transactionData, setTransactionData } = useTransactionData();
  const [isFetching, setIsFetching] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!transactionData?.id) {
      history.push(`/${id}/${token}${history.location.search}`);
    }
  }, [transactionData?.id, history, id, token]);

  return (
    <div className="flex justify-center items-center bg-white sm:bg-gray-900 font-arboria-book min-h-screen overflow-x-hidden">
      <div className="flex flex-col justify-between items-center w-[500px] rounded-[20px] overflow-hidden text-center">
        <Header title={i18n.t("header.previous")} />
        {isFetching ? (
          <CircularLoader />
        ) : error ? (
          <ErrorMessage>{error}</ErrorMessage>
        ) : (
          <LayoutWrapper1xbet>
            {transactionData?.merchant_request_amount && (
              <AmountInput1xbet
                value={transactionData?.merchant_request_amount}
                currency={transactionData?.merchant_request_currency_iso}
              />
            )}
            <PaymentDataForm
              data={transactionData}
              setData={setTransactionData}
              setError={setError}
              setIsFetching={setIsFetching}
            />
          </LayoutWrapper1xbet>
        )}
      </div>
    </div>
  );
}

export default PaymentData1xbet;
